<div>
  <ng-container *ngIf="(state | async)[stateKey].pep_data; else noPEPData">
    <table class="uk-table uk-table-divider uk-table-small uk-background-muted uk-table-responsive">
      <tbody>
        <tr>
          <td i18n="@@AMLReport">AML report</td>
          <td class="uk-text-right">
            <ng-container *ngIf="(state | async)[stateKey].pep_data.aml_report_url; else noAMLReport">
              <app-download-file [url]="(state | async)[stateKey].pep_data.aml_report_url"></app-download-file>
            </ng-container>
            <ng-template #noAMLReport>
              <span uk-icon="minus"></span>
            </ng-template>
          </td>
        </tr>

        <tr>
          <td i18n="@@CertificateOfIncorporation">Certificate of incorporation</td>
          <td class="uk-text-right">
            <ng-container
              *ngIf="(state | async)[stateKey].pep_data.certificate_of_incorporation_url; else noCertificateOfIncorporationFile">
              <app-download-file [url]="(state | async)[stateKey].pep_data.certificate_of_incorporation_url"> </app-download-file>
            </ng-container>
            <ng-template #noCertificateOfIncorporationFile>
              <span uk-icon="minus"></span>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>

    <h3 class="uk-margin-top uk-margin-remove-bottom" i18n="@@BeneficialOwners">Beneficial owners</h3>

    <div
      class="table-container uk-margin-bottom"
      [ngClass]="{ 'company-height': stateKey === 'company', 'investment-company-height': stateKey === 'investmentCompany' }">
      <table class="uk-table uk-table-divider uk-table-striped uk-table-hover uk-table-small uk-table-middle">
        <thead>
          <tr>
            <th i18n="@@name">name</th>
            <th i18n="@@dateOfBirth">date of birth</th>
            <th i18n="@@percentageControl">percentage control</th>
            <th i18n="@@status">status</th>
            <th i18n="@@ScreeningDate">screening date</th>
            <th class="uk-text-center@m" i18n="@@ReportFile">report</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let beneficialOwner of (state | async)[stateKey].pep_data.beneficial_owners; let i = index">
            <td>{{ beneficialOwner.first_name + ' ' + beneficialOwner.last_name }}</td>
            <td>{{ beneficialOwner.birth_date | date: 'dd.MM.y' }}</td>
            <td>{{ beneficialOwner.percentage_control }}%</td>
            <td>{{ beneficialOwner.status }}</td>
            <td>{{ beneficialOwner.created_date | date: 'dd.MM.y' }}</td>
            <td class="uk-text-center@m">
              <ng-container *ngIf="beneficialOwner.report_file_url; else noReportFile">
                <app-download-file [url]="beneficialOwner.report_file_url"></app-download-file>
              </ng-container>
              <ng-template #noReportFile>
                <span uk-icon="minus"></span>
              </ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <ng-template #noPEPData>
    <div class="uk-flex uk-flex-column uk-flex-center uk-flex-middle">
      <ng-container *ngIf="PEPCheckPerformed; else retrieveData">
        <span i18n="@@preparedPEPData">Data is being prepared, please refresh to check if it is available.</span>
        <button (click)="refresh()" i18n="@@refresh" class="uk-button button-primary uk-margin-small-top">refresh</button>
      </ng-container>

      <ng-template #retrieveData>
        <span i18n="@@noPEPData">PEP check has not been performed yet.</span>
        <button (click)="retrievePEPData()" i18n="@@retrieveData" class="uk-button button-primary uk-margin-small-top">
          retrieve data
        </button>
      </ng-template>
    </div>
  </ng-template>
</div>
